import {useTourTracking} from '../../analytics/TourTracking';
import { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import s from './TourQa.module.scss';

const TourQa = ({ qaData }) => {
  if(!qaData) return null;

  return (
    <div className={s.root}>
      <h3 className={s.title}>Q&A（よくある質問と回答）</h3>
      <div className={s.qaSection}>
        {qaData.map((qa, index) => (
          <QaItem key={index} question={qa.question} answer={qa.answer} />
        ))}
      </div>
    </div>
  );
};
const QaItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const track = useTourTracking();
  const toggleAnswer = () => {
    if (!isOpen) track('faq_open');
    setIsOpen((prev) => !prev);
  };

  return (
    <div className={s.qaItem}>
      <div className={s.question} onClick={toggleAnswer}>
        <span>{question}</span>
        {isOpen ? <FaChevronUp className={s.icon} /> : <FaChevronDown className={s.icon} />}
      </div>
      {isOpen && (
        <div className={s.answer}>
          <p>{answer}</p>
        </div>
      )}
    </div>
  );
};

export default TourQa;
